import { render, staticRenderFns } from "./ContentRichTextEditor.vue?vue&type=template&id=579b4d0e&scoped=true"
import script from "./ContentRichTextEditor.vue?vue&type=script&lang=js"
export * from "./ContentRichTextEditor.vue?vue&type=script&lang=js"
import style0 from "./ContentRichTextEditor.vue?vue&type=style&index=0&id=579b4d0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579b4d0e",
  null
  
)

export default component.exports